import React, { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Select from '../../common/Form/Select';
import { debounce } from '../../utils/common';
import { getTeamsDropDownList } from '../../actions/teams';
import { CLEAR_TEAMS_DROPDOWN_LIST_DATA } from '../../types/teams';

export default function Teams({ name, label, onChange = () => { }, org_id, isMulti = false, className, org_check_required = true, required = false, isDisabled = false, filter = [] }) {
    const dispatch = useDispatch();
    const teamsDropDownList = useSelector((state) => state.teams.teamsDropDownList);
    const isTeamsDropDownListLoading = useSelector((state) => state.loading.isTeamsDropDownListLoading);


    const memoizedTeamsDropDownList = useMemo(() => {
        const teamsOptions = teamsDropDownList || [];
        if (filter.length > 0) {
            return teamsOptions.filter((team) => !filter.includes(team.value));
        }
        return teamsOptions;
    }, [teamsDropDownList, filter]);

    const getTeams = ({ limit = 100, page = 1, query = '', org_id }) => {
        dispatch(getTeamsDropDownList({ limit, page, query, org_id }));
    };

    const debouncedTeamsSearchSearch = useCallback(debounce(getTeams), []);

    useEffect(() => {
        if ((org_check_required && org_id) || !org_check_required) {
            let payload = {
                limit: 100,
                page: 1,
            }
            if (org_check_required) payload.org_id = org_id;
            getTeams(payload);
        }
    }, [org_id]);

    useEffect(() => {
        return () => {
            dispatch({ type: CLEAR_TEAMS_DROPDOWN_LIST_DATA });
        }
    }, [dispatch]);

    return (
        <Select
            required={required}
            className={className}
            label={label}
            name={name}
            options={memoizedTeamsDropDownList}
            isLoading={isTeamsDropDownListLoading}
            onInputChange={(event) => {
                if (event.length > 0) {
                    let p = { query: event };
                    if (org_check_required && org_id) p.org_id = org_id;
                    debouncedTeamsSearchSearch(p);
                }
            }}
            onChange={(event) => {
                const value = event?.value;
                onChange(value)
            }}
            isMulti={isMulti}
            readOnly9={isDisabled}
        />
    )
}